import { PayloadAction } from '@reduxjs/toolkit';
import { ActiveFilters, SearchState } from '../types';

const setDefaultFiltersReducer = (state: SearchState, action: PayloadAction<ActiveFilters>) => {
  state.settings.defaultFilters = action.payload;
};

export default setDefaultFiltersReducer;
